import { Component, OnInit, Input, Output } from '@angular/core';
import { OrdersRouterService } from 'src/app/services/api/router/orders-router.service';
import { TabObject } from 'src/app/models/orders/item/tab-object.model';
import { TabListObject } from 'src/app/models/orders/item/tab-list-object.model';
import { TabIndexObject } from 'src/app/models/orders/item/tab-index-object.model';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';
import { EventEmitter } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';

@Component({
  selector: 'app-order-crm',
  templateUrl: './order-crm.component.html',
  styleUrls: ['./order-crm.component.scss']
})
export class OrderCrmComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();

  private tabList: TabListObject;
  selectedIndex: number = 0;

  constructor(private routerService: OrdersRouterService) {

  }

  ngOnInit() {
    this.tabList = new TabListObject();
    this.tabList.add(new TabIndexObject(0, TabObject.GENERAL_TAB));
  }

  public goToTab($event): void {
    const tab: TabObject = this.tabList.getTab($event.index);

    this.routerService.navigate(new ItemObject(this.params.id, this.params.map, OrderTypeObject.CRM, tab));
  }

  cancelOrder() {
    this.cancelOrderEvent.emit();
  }
}
